import { render, staticRenderFns } from "./FootDouble3230.vue?vue&type=template&id=39a96786"
import script from "./FootDouble3230.vue?vue&type=script&lang=js"
export * from "./FootDouble3230.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports